module.exports = __webpack_public_path__ + "img/check-number-blue.61acac23.svg";